import { BonusCustomerCondition } from '@synergy/models';

import { getConditionValue } from './get-condition-value';

export function getConditionCalculatedBonus(
    value: string | null,
    bonusConditionId: number,
    bonusConditions: BonusCustomerCondition[]
): number {
    const condition = bonusConditions.find(c => c.bonusCondition.id === bonusConditionId);

    if (!condition) {
        return 0;
    }

    return getConditionValue(condition) * (value ? Number(value) : 0);
}
